import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { UserSettings } from "@/data/models/Settings";
import { createDefaultUserSettings } from "@/data/models/Client";

const name = "userSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class UserSettingsVuexModule extends VuexModule {
  userSettings: UserSettings = createDefaultUserSettings();

  @Mutation
  setUserSettings(userSettings: UserSettings) {
    this.userSettings = userSettings;
  }

  @Mutation
  clear() {
    this.userSettings = createDefaultUserSettings();
  }
}

export const UserSettingsModule = getModule(UserSettingsVuexModule, store);
